import { Button as ButtonUI } from "@/components/ui/button";

export { ButtonUI as Button };
